import { Injectable } from '@angular/core';

import { ConfigurationService } from 'src/core/index/services.index';
import { MenuItem, ViewerToolbarTool } from 'src/index';

@Injectable({
    providedIn: 'root'
})
export class ConfigurationServiceCustom extends ConfigurationService {

    constructor() {
        super();
        this.appSections.courses.label = 'EconoMia';
        this.appSections.myCourses.label = 'My course';
        this.registrationStepFields = [this.registrationStepFields[0]];
    }

    override getViewerToolbarTools(): ViewerToolbarTool[] {
        const tools = [
            this.viewerToolbarTools.index,
            this.viewerToolbarTools.workbook,
            this.viewerToolbarTools.bookmarks,
            this.viewerToolbarTools.cut,
            this.viewerToolbarTools.accessibility,
        ];
        return tools;
    }

    override getDashboardMenuItems(): MenuItem[] {
        return [
            this.appSections.dashboard,
            this.appSections.courses,
            this.appSections.myCourses,
            this.appSections.calendar,
        ];
    }

    override getUserMenuItems(): MenuItem[] {
        return [
            this.appSections.profile,
            this.appSections.logout,
            this.appSections.help,
        ];
    }
}